import React from 'react';
import styles from './HealthPanel.module.css';

interface HealthPanelProps {
  totalResources: number;
  critical: number;
  warning: number;
  neutral: number;
  good: number;
}

export const HealthPanel: React.FC<HealthPanelProps> = ({
  totalResources,
  critical,
  warning,
  neutral,
  good,
}) => {
  const criticalPercent = (critical / totalResources) * 100;
  const warningPercent = (warning / totalResources) * 100;
  const neutralPercent = (neutral / totalResources) * 100;
  const goodPercent = (good / totalResources) * 100;

  return (
    <div className={styles.healthPanel}>
      <h3 className={styles.title}>Health</h3>
      <div className={styles.content}>
        <div className={styles.totalResources}>
          <span className={styles.totalValue}>{totalResources.toLocaleString()}</span>
          <span className={styles.totalLabel}>Total resources</span>
        </div>
        <div className={styles.barChart}>
          <div className={styles.barSegment} style={{ width: `${criticalPercent}%`, backgroundColor: '#e21d3c' }}></div>
          <div className={styles.barSegment} style={{ width: `${warningPercent}%`, backgroundColor: '#ffc107' }}></div>
          <div className={styles.barSegment} style={{ width: `${neutralPercent}%`, backgroundColor: '#00bfff' }}></div>
          <div className={styles.barSegment} style={{ width: `${goodPercent}%`, backgroundColor: '#28a745' }}></div>
        </div>
        <div className={styles.legend}>
          <div className={styles.legendItem}>
            <span className={styles.legendValue}>{critical.toLocaleString()}</span>
            <div className={styles.legendLabelGroup}>
              <span className={styles.legendDot} style={{ backgroundColor: '#e21d3c' }}></span>
              <span className={styles.legendLabel}>Critical</span>
            </div>
          </div>
          <div className={styles.legendItem}>
            <span className={styles.legendValue}>{warning.toLocaleString()}</span>
            <div className={styles.legendLabelGroup}>
              <span className={styles.legendDot} style={{ backgroundColor: '#ffc107' }}></span>
              <span className={styles.legendLabel}>Warning</span>
            </div>
          </div>
          <div className={styles.legendItem}>
            <span className={styles.legendValue}>{neutral.toLocaleString()}</span>
            <div className={styles.legendLabelGroup}>
              <span className={styles.legendDot} style={{ backgroundColor: '#00bfff' }}></span>
              <span className={styles.legendLabel}>Neutral</span>
            </div>
          </div>
          <div className={styles.legendItem}>
            <span className={styles.legendValue}>{good.toLocaleString()}</span>
            <div className={styles.legendLabelGroup}>
              <span className={styles.legendDot} style={{ backgroundColor: '#28a745' }}></span>
              <span className={styles.legendLabel}>Good</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

